import React from "react";
import "../Learn.scss";
import phone from "../../images/phone.svg";

import arrow from "../../images/arrow.svg";
const LearnComponent = () => {
  return (
    <div id="learn" className="learnPage">
      <div className="learnComponent">
        <div className="LeftLearnSection">
          <h1 className="agencyTitile">
            stop <span className="orangeTitle">selling yourself.</span>
          </h1>
          <p className="patagraphHeroH">
            There is more in life than prospection. Just focus on your craft and
            let us take care of the rest
          </p>
        </div>
        <div className="RightLearnSection">
          <div className="LearnItem">
          <div className="mobileLayout">
            <img className="learnImage" src={phone} alt="phone" />
            <h1 className="learnTitile">dedicated landing page</h1>
            </div>
            <p className="patagraphLearn">
              There is more in life than prospection. Just focus on your craft
              and let us take care of the rest
            </p>
          </div>
          <div className="LearnItem">
            <div className="mobileLayout">
              <img className="learnImage" src={arrow} alt="phone" />
              <h1 className="learnTitile">purchasable prospect</h1>
            </div>
            <p className="patagraphLearn">
              Use snikpic’s experience running ads and only buy from us prospect
              who have shown direct interest in your profile. We take care of
              the rest
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LearnComponent;
